var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpened = function SvgEyeOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.29 10.93C19.43 7.48 15.75 4 11.75 4C7.75 4 4.07 7.48 2.21 10.93C1.93 11.45 1.93 12.06 2.21 12.58C4.07 16.03 7.75 19.51 11.75 19.51C15.75 19.51 19.43 16.03 21.29 12.58C21.57 12.06 21.57 11.45 21.29 10.93ZM11.75 18C8.86 18 5.48 15.48 3.53 11.86C3.49 11.79 3.49 11.71 3.53 11.64C5.49 8.03 8.87 5.5 11.75 5.5C14.63 5.5 18.02 8.02 19.97 11.64C20.01 11.71 20.01 11.79 19.97 11.86C18.01 15.47 14.63 18 11.75 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.04004C9.70004 8.04004 8.04004 9.71004 8.04004 11.75C8.04004 13.79 9.71004 15.46 11.75 15.46C13.79 15.46 15.46 13.79 15.46 11.75C15.46 9.71004 13.79 8.04004 11.75 8.04004ZM11.75 14.04C10.49 14.04 9.46004 13.01 9.46004 11.75C9.46004 10.49 10.49 9.46004 11.75 9.46004C13.01 9.46004 14.04 10.49 14.04 11.75C14.04 13.01 13.01 14.04 11.75 14.04Z",
    fill: "currentColor"
  })));
};
export default SvgEyeOpened;